import React, {useState, useEffect} from 'react';
import {Location} from '@reach/router';
import {Col, Container, Row, Button} from 'reactstrap';

import PageMeta from 'components/PageMeta';
import Header from 'components/Elements/Header';
import SectionCL from 'components/ComponentLibrary/SectionCL';
import ResourceTabs, {ResourceTabNav} from 'components/Resources/ResourceTabs';
import ProductImage from 'components/Elements/ProductImage';
import Footer from 'components/Elements/Footer';

export default (props) => (
  <Location>
    {({location}) => {
      const addProps = {};
      if (location && location.hash) {
        const matches = location.hash.match(/^#tab-(\d)/);
        if (matches && matches.length === 2) addProps.activePanel = parseInt(matches[1]) - 1;
      }
      return <Resources {...props} {...addProps} location={location} />;
    }}
  </Location>
);

function Resources({location, ...props}) {
  const [activePanel, setActivePanel] = useState(props.activePanel || 0);
  useEffect(() => {
    setActivePanel(props.activePanel);
  }, [props.activePanel]);

  return (
    <div className="page page-nosocial d-flex flex-column">
      <PageMeta title="Resources" description="The future of your heart health is up to you." />

      <div className="page-content">
        <Header bgColor="black" lockupWhite />
        <SectionCL id="" color="purple" className="text-center text-white" innerClass="py-4" angle="none" order="first">
          <Container>
            <Row>
              <Col>
                <h2 className="section-only-heading text-center">Resources</h2>
              </Col>
            </Row>
          </Container>
        </SectionCL>

        <SectionCL id="" color="white" innerClass="pt-4 pt-lg-5" angle="none" order="last">
          <Container>
            <Row>
              <Col lg="8">
                <ResourceTabs activePanel={activePanel} />
              </Col>
              <Col lg="4">
                <div className="resource-tab-wrap">
                  <ResourceTabNav setActivePanel={setActivePanel} activePanel={activePanel} />
                </div>

                <div className="resource-ep background-gradient-indigo-purple-right p-4 rounded text-white text-center">
                  <h6 className="section-heading">
                    The Pivotal Question: Is what I’m eating and doing helping me…or harming me?
                  </h6>
                  <h6 className="mt-0">Your future is up to you!</h6>
                  <p>
                    Join <i>Tackling Type 2</i> today.
                  </p>
                  <ProductImage
                    className="background-white p-1 rounded mb-3"
                    img="https://cdn.foodrevolution.org/tt2/TT2-Product_Image-v20220812_2.png"
                    width="1200"
                    height="500"
                  />
                  <Button color="cta" href="/join" target="_blank" block>
                    Learn More
                  </Button>
                </div>
              </Col>
            </Row>
          </Container>
        </SectionCL>
      </div>

      <div className="footer-content mt-auto">
        <Footer />
      </div>
    </div>
  );
}
